import { Header } from '../components/landing/Header';
import { HeroSection } from '../components/landing/HeroSection';
import { BookingSection } from '../components/landing/BookingSection';
import { ProblemSection } from '../components/landing/ProblemSection';
import { PositioningSection } from '../components/landing/PositioningSection';
import { ValueBlocks } from '../components/landing/ValueBlocks';
import { CategoryFrame } from '../components/landing/CategoryFrame';
import { FitSection } from '../components/landing/FitSection';
import { GrowthSection } from '../components/landing/GrowthSection';
import { SetupSection } from '../components/landing/SetupSection';
import { PricingTeaser } from '../components/landing/PricingTeaser';
import { CTASection } from '../components/landing/CTASection';
import { Footer } from '../components/landing/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-[#faf9f6]">
      <Header />
      <main>
        <HeroSection />
        <BookingSection />
        <ProblemSection />
        <PositioningSection />
        <ValueBlocks />
        <CategoryFrame />
        <FitSection />
        <GrowthSection />
        <SetupSection />
        <PricingTeaser />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
